import PropTypes from "prop-types";

const Logo = (props) => {
  const { dalenta = true, sello, visuo, color = "#8F8F8F", className, width = "18", height = "18" } = props;

  if (visuo) {
    return (
      <svg className={className} width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.99987 1.51677C5.47991 0.527841 7.21997 0 9 0C10.1819 0 11.3522 0.232792 12.4442 0.685084C13.5361 1.13738 14.5282 1.80031 15.364 2.63604C16.1997 3.47177 16.8626 4.46392 17.3149 5.55585C17.7672 6.64778 18 7.8181 18 9C18 10.78 17.4722 12.5201 16.4832 14.0001C15.4943 15.4802 14.0887 16.6337 12.4442 17.3149C10.7996 17.9961 8.99002 18.1743 7.24419 17.8271C5.49836 17.4798 3.89471 16.6226 2.63604 15.364C1.37737 14.1053 0.520203 12.5016 0.172937 10.7558C-0.17433 9.00998 0.0038995 7.20038 0.685088 5.55585C1.36628 3.91131 2.51983 2.50571 3.99987 1.51677ZM5.79992 13.7893C6.74714 14.4222 7.86078 14.76 9 14.76C10.5276 14.76 11.9927 14.1531 13.0729 13.0729C14.1531 11.9927 14.76 10.5276 14.76 9C14.76 7.86078 14.4222 6.74714 13.7893 5.79991C13.1563 4.85269 12.2568 4.11441 11.2043 3.67845C10.1518 3.24249 8.99361 3.12842 7.87628 3.35068C6.75895 3.57293 5.73262 4.12151 4.92707 4.92706C4.12152 5.73261 3.57293 6.75895 3.35068 7.87628C3.12843 8.99361 3.2425 10.1517 3.67846 11.2043C4.11442 12.2568 4.85269 13.1563 5.79992 13.7893Z"
          fill={color}
        />
        <path
          d="M12.6 9C12.6 10.9882 10.9882 12.6 9 12.6C7.01177 12.6 5.4 10.9882 5.4 9C5.4 7.01177 7.01177 5.4 9 5.4C10.9882 5.4 12.6 7.01177 12.6 9Z"
          fill={color}
        />
      </svg>
    );
  } else if (sello) {
    return (
      <svg className={className} width={width} height={height} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.134589 7.02824C-0.0448632 6.84878 -0.0448627 6.55784 0.134589 6.37838L6.37746 0.13551C6.66694 -0.153969 7.1619 0.0510528 7.1619 0.460437L7.1619 12.9462C7.1619 13.3556 6.66694 13.5606 6.37746 13.2711L0.134589 7.02824Z"
          fill={color}
        />
        <path
          d="M17.8654 7.02824C18.0449 6.84878 18.0449 6.55784 17.8654 6.37838L11.6225 0.13551C11.3331 -0.153969 10.8381 0.0510528 10.8381 0.460437V12.9462C10.8381 13.3556 11.3331 13.5606 11.6225 13.2711L17.8654 7.02824Z"
          fill={color}
        />
      </svg>
    );
  } else if (dalenta) {
    return (
      <svg className={className} width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.19202 9.46358C-0.0640067 9.20755 -0.0640068 8.79245 0.19202 8.53642L8.53642 0.19202C8.79245 -0.0640066 9.20755 -0.0640068 9.46358 0.19202L17.808 8.53642C18.064 8.79245 18.064 9.20755 17.808 9.46358L9.46358 17.808C9.20755 18.064 8.79245 18.064 8.53642 17.808L0.19202 9.46358ZM9.46358 3.15892C9.20755 2.90289 8.79245 2.90289 8.53642 3.15892L7.14569 4.54965L11.596 9L7.14569 13.4503L8.53642 14.8411C8.79245 15.0971 9.20755 15.0971 9.46358 14.8411L14.8411 9.46358C15.0971 9.20755 15.0971 8.79245 14.8411 8.53642L9.46358 3.15892Z"
          fill={color}
        />
      </svg>
    );
  }
};

Logo.propTypes = {
  sello: PropTypes.bool,
  visuo: PropTypes.bool,
  dalenta: PropTypes.bool,
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default Logo;
